import { render, staticRenderFns } from "./KPIReport.vue?vue&type=template&id=05c6f671&scoped=true"
import script from "./KPIReport.vue?vue&type=script&lang=js"
export * from "./KPIReport.vue?vue&type=script&lang=js"
import style0 from "./KPIReport.vue?vue&type=style&index=0&id=05c6f671&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c6f671",
  null
  
)

export default component.exports